/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SubmitCaseImage } from './SubmitCaseImage';
export type OpenCaseCommand = {
    serial?: string;
    imei?: string;
    os?: OpenCaseCommand.os;
    model?: string;
    entityType?: OpenCaseCommand.entityType;
    entityId?: string;
    images?: Array<SubmitCaseImage>;
};
export namespace OpenCaseCommand {
    export enum os {
        IOS = 'IOS',
        ANDROID = 'ANDROID',
    }
    export enum entityType {
        SHOP = 'SHOP',
        FINANCIER = 'FINANCIER',
    }
}

